module.exports = __webpack_public_path__ + "img/step24_open_cover_stacker_tray.88466164.png";